import Swiper from 'swiper';
import { Manipulation, Navigation, Pagination, Zoom, Thumbs } from 'swiper/modules';

// ===============================================================
// CUSTOM PAGINATION - SWIPER - VERTICAL THUMBS
// ===============================================================
function handleCustomPagination() {
  const thumbs = document.querySelectorAll('[data-slider-thumbs] .swiper-slide');

  if (thumbs) {
    const halfWindowHeight = window.innerHeight / 2; // Considera o elemento ativo quando estiver em 50% da tela

    window.addEventListener('scroll', function () {
      const productImages = document.querySelectorAll('[data-image]');
      const viewportTop = window.scrollY; // Altura da tela atual - Considerando scroll
      const viewportBottom = viewportTop + window.innerHeight;

      productImages.forEach((image) => {
        // Calcula topo e base do elemento na tela para verificar se está visível
        // Considera que esteja ao menos em 50% da altura total da tela
        const elementTop = image.offsetTop + halfWindowHeight;
        const elementBottom = elementTop + image.offsetHeight;

        const activeThumb = document.querySelector(`[data-image-index="${image.getAttribute('id')}"]`);

        // Verifica se o elemento está visível em tela e tem uma thumb relacionado à ele
        if (elementBottom > viewportTop && elementTop < viewportBottom && activeThumb) {
          thumbs.forEach((el) => el.parentElement.classList.remove('-active'));
          activeThumb.parentElement.classList.add('-active');
        }
      });
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        // Limpa os demais elementos
        thumbs.forEach((el) => el.parentElement.classList.remove('-active'));

        const relativeSlide = thumb.getAttribute('data-image-index');
        const parentElement = thumb.parentElement;
        parentElement.classList.add('-active'); // Adiciona a classe de elemento ativo no item clicado
        console.log(relativeSlide);

        if (relativeSlide) {
          // Conduz o swiper até o elemento que contém a mesma identificação do thumb
          const elementToScroll = document.getElementById(relativeSlide);
          elementToScroll &&
            window.scroll({
              top: elementToScroll.offsetTop + 24,
              left: 0,
              behavior: 'smooth',
            });
        }
      });
    });
  }
}

export default function setGallery(Product) {
  const thumbs = new Swiper(Product.thumbsSlider.element, {
    modules: [Manipulation],
    direction: 'vertical',
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 10,
    watchSlidesProgress: true,
    watchOverflow: true,
    preloadImages: false,
    lazy: {
      checkInView: true,
      loadOnTransitionStart: true,
    },
  });

  const main = new Swiper(Product.mainSlider.element, {
    modules: [Manipulation, Navigation, Pagination, Zoom, Thumbs],
    slidesPerView: 1,
    slidesPerGroup: 1,
    speed: 1000,
    watchSlidesProgress: true,
    watchOverflow: true,
    preloadImages: false,
    navigation: {
      nextEl: '[data-product-images] .swiper-button-next',
      prevEl: '[data-product-images] .swiper-button-prev',
    },
    pagination: {
      el: '.product-images .swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    breakpoints: {
      768: {
        direction: 'horizontal',
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
    lazy: {
      checkInView: true,
      loadOnTransitionStart: true,
    },
    // zoom: {
    //   maxRatio: 2,
    //   zoomedSlideClass: '-zoomed',
    // },
    on: {
      init: function () {
        window.innerWidth >= 767 && handleCustomPagination();
      },
    },
  });

  Product.thumbsSlider.swiper = thumbs;
  Product.mainSlider.swiper = main;
}
